import React, { FC } from 'react'

import { IconVodafoneProps } from './IconVodafone.types'
import * as Styled from './styles/IconVodafone.style'

import { nonThemeableRules } from '../../ruleSet'

const IconVodafone: FC<IconVodafoneProps> = ({
  size = nonThemeableRules.defaultSize as number as IconVodafoneProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconVodafoneProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M23.824 20.298a8.395 8.395 0 0 1-2.289 2.781 8.574 8.574 0 0 1-3.045 1.533 8.503 8.503 0 0 1-4.679-.033 9.05 9.05 0 0 1-3.937-2.36 9.084 9.084 0 0 1-1.168-1.459 9.757 9.757 0 0 1-1.218-2.787 10.423 10.423 0 0 1-.293-1.582 11.029 11.029 0 0 1-.047-1.817c.046-.792.163-1.562.345-2.3.728-2.954 2.467-5.451 4.503-7.175 1.358-1.165 2.896-1.996 4.386-2.57a17.409 17.409 0 0 1 4.153-1.028c.863-.095 1.567-.09 2.02-.018.128.02.237.047.323.077-2.974.644-5.216 3.273-5.216 6.415 0 .07.014.153.018.217 1.307.275 2.436.718 3.382 1.302a7.64 7.64 0 0 1 2.349 2.234c.42.624.742 1.311.966 2.051a9.156 9.156 0 0 1 .377 2.63c0 1.36-.32 2.697-.93 3.889M16 0C7.164 0 0 7.164 0 15.998 0 24.838 7.164 32 16 32c8.838 0 16-7.163 16-16.002C32 7.164 24.838 0 16 0'
          fill='#E60000'
          fillRule='evenodd'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconVodafone
